import { all_routes } from "../../../feature-module/router/all_routes";
const route = all_routes;

export const SidebarData = [
  {
    label: "MAIN MENU",
    name: "Main Menu",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Main",
    submenu: false,
    submenuItems: [
      {
        label: "Dashboard",
        name: "dashboard",
        icon: "ti ti-layout-dashboard",
        showSubRoute: false,
        link: "/dashboard/deals-dashboard",
        submenu: false,
      },
    ],
  },
  {
    label: "PEOPLE",
    name: "People",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "People",
    submenuItems: [
      {
        label: "Employees",
        name: "Employees",
        link: "/employees",
        icon: "ti ti-users",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Employee Types",
        name: "Employee-Types",
        link: "/employee-types",
        icon: "ti ti-id-badge-2",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Contract Type",
        name: "Contract Type",
        link: route.ContractType,
        icon: "ti ti-file-text",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Departments",
        name: "Departments",
        link: route.Department,
        icon: "ti ti-building",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Areas",
        name: "Area",
        link: route.areas,
        icon: "ti ti-map-pin",
        showSubRoute: false,
        submenu: false,
      },
      // Tenancy §7.1: platform-admin only, gated by isPlatformAdmin rather
      // than a Permissions V2 key — see PLATFORM_ADMIN_ONLY_ITEMS in
      // core/common/sidebar/index.tsx.
      {
        label: "Companies",
        name: "PlatformAdminCompanies",
        link: route.tenants,
        icon: "ti ti-building-skyscraper",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Data Sharing",
        name: "PlatformAdminSharing",
        link: route.tenantShares,
        icon: "ti ti-arrows-exchange",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Data Replication",
        name: "PlatformAdminReplication",
        link: route.tenantDataReplication,
        icon: "ti ti-copy",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Volunteer",
        name: "Volunteer",
        link: "/volunteer-list",
        icon: "ti ti-heart-handshake",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Shift Type",
        name: "Shift Type",
        link: route.shiftList,
        icon: "ti ti-clock-hour-4",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Site Type",
        name: "Site Type",
        link: route.SiteType,
        icon: "ti ti-map-2",
        showSubRoute: false,
        submenu: false,
      }
    ],
  },
  {
    label: "HR",
    name: "HR",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "HR",
    submenuItems: [
      {
        label: "Attendance",
        name: "Attendance",
        link: "/attendance",
        icon: "ti ti-clock-check",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Leave Types",
        name: "Leave Types",
        link: route.LeaveType,
        icon: "ti ti-tag",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Holiday Request",
        name: "HolidayRequest",
        link: "/HolidayRequest-list",
        icon: "ti ti-calendar-plus",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Inductions",
        name: "Employee Induction",
        link: route.inductionList,
        icon: "ti ti-clipboard-check",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Induction Templates",
        name: "Induction Templates",
        link: route.inductionSettings,
        icon: "ti ti-template",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Extra Wages",
        name: "Extra Wages",
        link: route.ExtraWages,
        icon: "ti ti-cash-banknote",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Clothing Item",
        name: "ClothingItem",
        link: "/ClothingItem-list",
        icon: "ti ti-shirt",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Clothing Request",
        name: "ClothingRequest",
        link: "/ClothingRequest-list",
        icon: "ti ti-shopping-bag",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Clothing Returns",
        name: "Clothing Return",
        link: "/ClothingReturn-list",
        icon: "ti ti-arrow-back-up",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Custom Email",
        name: "Custom Email",
        link: route.customEmail,
        icon: "ti ti-mail",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Custom WhatsApp",
        name: "Custom WhatsApp",
        link: route.customWhatsApp,
        icon: "ti ti-brand-whatsapp",
        showSubRoute: false,
        submenu: false,
      },
    ],
  },
  {
    label: "OPERATIONS",
    name: "Operations",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Operations",
    submenuItems: [
      {
        label: "Customers",
        name: "Customers",
        link: "/customers",
        icon: "ti ti-building-store",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Farms",
        name: "Farms",
        link: "/farms-list",
        subLink1: "/farms-grid",
        subLink2: "/farms-details",
        icon: "ti ti-plant-2",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Teams",
        name: "Teams",
        link: "/team-list",
        icon: "ti ti-users-group",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Vehicles & Assets",
        name: "Vehicles",
        link: route.Vehicles,
        icon: "ti ti-truck",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Driver Trip Report",
        name: "DriverTripReport",
        link: route.DriverTripReport,
        icon: "ti ti-steering-wheel",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Machines",
        name: "Machines",
        link: route.Machines,
        icon: "ti ti-tractor",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Machine Assignments",
        name: "Machine Assignments",
        link: route.MachineAssignments,
        icon: "ti ti-clipboard-check",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Tracking",
        name: "TrackingList",
        link: "/tracking",
        icon: "ti ti-gps",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Check In/Out Settings",
        name: "Check In Out Settings",
        link: "/check-in-out/settings",
        icon: "ti ti-login",
        showSubRoute: false,
        submenu: false,
      },
    ],
  },
  {
    label: "TRAINING & COMPLIANCE",
    name: "Training & Compliance",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Training & Compliance",
    submenuItems: [
      {
        label: "Training Dashboard",
        name: "Training Dashboard",
        link: route.trainingDashboard,
        icon: "ti ti-layout-dashboard",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Trainings",
        name: "Trainings",
        link: "/training/modules",
        icon: "ti ti-school",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Training Categories",
        name: "Training Categories",
        link: "/training/categories",
        icon: "ti ti-tag",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Training Assignments",
        name: "Training Assignments",
        link: "/training/assignments",
        icon: "ti ti-clipboard-list",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "My Trainings",
        name: "myTraining",
        link: "/sop/my-training",
        icon: "ti ti-book",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "SOP",
        name: "sop",
        link: "/sop/list",
        icon: "ti ti-file-check",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Certifications",
        name: "Certifications",
        link: route.Certifications,
        icon: "ti ti-certificate",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Important Documents",
        name: "Important Docs",
        link: route.importantDocs,
        icon: "ti ti-file-certificate",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Training Record Requests",
        name: "Training Record Request",
        link: route.auditDocRequestDashboard,
        icon: "ti ti-clipboard-list",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Certificate Types",
        name: "Certificate Types",
        link: route.certificateTypes,
        icon: "ti ti-rosette",
        showSubRoute: false,
        submenu: false,
      },
    ],
  },
  {
    label: "AUDIT",
    name: "Audit",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Audit",
    submenuItems: [
      {
        label: "Audit Type",
        name: "auditType",
        link: "/audit/type",
        icon: "ti ti-list-check",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Audit Report",
        name: "auditReport",
        link: "/audit/report",
        icon: "ti ti-report-analytics",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Audit Scheduling",
        name: "audit",
        link: "/audit",
        icon: "ti ti-calendar-event",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Auditing Clock In/Out",
        name: "Auditing Clock In/Out Times",
        link: route.auditorTimesheet,
        icon: "ti ti-clock-hour-2",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Employee Companies",
        name: "Employee Companies",
        link: route.EmployeeCompany,
        icon: "ti ti-building-store",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Audit Escalations",
        name: "auditEscalations",
        link: route.auditEscalations,
        icon: "ti ti-alert-triangle",
        showSubRoute: false,
        submenu: false,
      },
    ],
  },
  {
    label: "CUSTOMER MANAGEMENT",
    name: "Customer Management",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Customer Management",
    submenuItems: [
      {
        label: "Customer Permissions",
        name: "CustomerPermissions",
        link: "/customer-management/permissions",
        icon: "ti ti-lock",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Customer Request Report",
        name: "customerRequestReport",
        link: "/customer-request-report",
        icon: "ti ti-file-analytics",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "NCR Template",
        name: "Non Conformances Report",
        link: route.nonConformancesReport,
        icon: "ti ti-alert-triangle",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "NCR Report Submission",
        name: "Non Conformances Report Submissions",
        link: route.ncrSubmission,
        icon: "ti ti-file-alert",
        showSubRoute: false,
        submenu: false,
      },
    ],
  },
  {
    label: "REPORTS",
    name: "Reports",
    submenuHdr: "Reports",
    submenuOpen: true,
    showSubRoute: false,
    submenu: false,
    submenuItems: [
      {
        label: "Reports",
        name: "All Reports",
        link: "/reports/all-reports",
        icon: "ti ti-chart-dots-3",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Reports Submission",
        name: "Submission Reports",
        link: "/reports/submission-reports",
        icon: "ti ti-file-spreadsheet",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Van Photo",
        name: "Van Photo",
        link: "/van-photo",
        icon: "ti ti-camera",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Sanitization",
        name: "Sanitized Reports",
        link: "/reports/sanitized-reports",
        icon: "ti ti-shield-check",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Incident Report",
        name: "Incident Report",
        link: route.incidentReport,
        icon: "ti ti-alert-octagon",
        showSubRoute: false,
        submenu: false,
      },
    ],
  },
  {
    label: "NOTIFICATIONS",
    name: "Notification",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Notifications",
    submenu: true,
    submenuItems: [
      {
        label: "Notification Types",
        name: "NotificationType",
        link: "/notification/types",
        icon: "ti ti-bell",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Notification Template",
        name: "NotificationTemplate",
        link: "/notification/template",
        icon: "ti ti-template",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "System Report",
        name: "SystemReport",
        link: "/notification/system-report",
        icon: "ti ti-report",
        showSubRoute: false,
        submenu: false,
      },
    ],
  },
  {
    label: "SETTINGS",
    name: "Settings",
    submenuOpen: true,
    submenuHdr: "Settings",
    submenu: false,
    showSubRoute: false,
    submenuItems: [
      {
        label: "Roles & Permission",
        name: "roles",
        link: "/user-management/roles-permissions",
        icon: "ti ti-shield-lock",
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "System Settings",
        name: "System Setting",
        link: "/settings/system",
        icon: "ti ti-settings",
        showSubRoute: false,
        submenu: false,
      },
      // Driver Score Settings — hidden for now, to be re-enabled once the scoring
      // configuration is actually used. The route, page and panel all still exist;
      // restoring the menu item is the only change needed.
      // {
      //   label: "Driver Score Settings",
      //   name: "DriverTripReportSettings",
      //   link: route.DriverTripReportSettings,
      //   icon: "ti ti-steering-wheel",
      //   showSubRoute: false,
      //   submenu: false,
      // },
    ],
  },
];
